<mat-select
  class="lum-select"
  [(ngModel)]="value"
  [placeholder]="placeholder"
  (selectionChange)="onSelectUser($event)"
>
  <mat-option value="">--None--</mat-option>
  <mat-option
    *ngFor="let option of users; trackBy: trackByValue"
    [value]="option.value"
  >
    {{ option.label }}
  </mat-option>
</mat-select>
